import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import RadioButtonStacked from 'v-c/Forms/RadioButtons/RadioButtonStacked';

const FILE_TYPES = ['eml', 'pst', 'pdf'];

export default function ExportSelectFormat({ onSelect, selectedType }) {
    const data = FILE_TYPES.map(id => ({
        id,
        value: `.${id.toUpperCase()}`,
    }));

    return (
        <RadioButtonStacked
            id="file-formats"
            onSelect={onSelect}
            selectedId={selectedType}
            data={data}
        />
    );
}

ExportSelectFormat.displayName = displayName('Dropdowns/ExportDropdownViews/SelectFormat');

ExportSelectFormat.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedType: PropTypes.string.isRequired,
};
